import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';

export const ALLOWED_DEVIATION_TYPES = [DeviationTypes.IMAGE];

export const ALLOWED_MEDIA_SOURCE_TYPES = [
  MediaSourceType.GALLERY,
  MediaSourceType.STASH,
];

export const DEFAULT_COLOR = '#ffffff';
